const BASE = process.env.REACT_APP_ACTOR_API_URL || 'http://localhost:3001';

async function call(path, options = {}) {
  const res  = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Request failed');
  return json.data;
}

export const signup         = (body)  => call('/signup',         { method: 'POST', body: JSON.stringify(body) });
export const login          = (body)  => call('/login',          { method: 'POST', body: JSON.stringify(body) });
export const verifyOTP      = (body)  => call('/verify-otp',     { method: 'POST', body: JSON.stringify(body) });
export const getMe          = (token) => call('/me',             { headers: { Authorization: `Bearer ${token}` } });
export const forgotPassword = (body)  => call('/forgot-password',{ method: 'POST', body: JSON.stringify(body) });
export const resetPassword  = (body)  => call('/reset-password', { method: 'POST', body: JSON.stringify(body) });
export const refreshTokens  = (refreshToken) => call('/refresh', { method: 'POST', body: JSON.stringify({ refreshToken }) });
